import { formatBRL } from '@dnx/contracts';
import { Badge, Button, Card, CardHeader } from '@dnx/ui';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { Plus } from 'lucide-react';
import { useState } from 'react';
import { meQuery } from '../lib/session.js';
import { NewQuoteDialog } from './quotes-page.js';
import { QUOTE_STATUS, quotesQuery } from './queries.js';

/** Orçamentos do paciente, na ficha (para quem vê orçamentos). */
export function PatientQuotes({ patientId }: { patientId: string }) {
  const { data: me } = useSuspenseQuery(meQuery);
  const canRead = me.permissions.includes('billing.quote.read');
  const canWrite = me.permissions.includes('billing.quote.write');
  const { data } = useQuery({ ...quotesQuery(patientId), enabled: canRead });
  const [creating, setCreating] = useState(false);
  if (!canRead) return null;
  return (
    <Card>
      <CardHeader title="Orçamentos" action={canWrite && <Button size="sm" variant="secondary" onClick={() => setCreating(true)}><Plus className="size-3.5" />Novo</Button>} />
      <ul className="divide-y divide-border">
        {data?.map((q) => (
          <li key={q.id}>
            <Link to="/orcamentos/$id" params={{ id: q.id }} className="flex items-center gap-3 px-5 py-3 text-sm hover:bg-surface-muted">
              <span className="font-mono text-[12.5px] text-fg-muted">{q.code}</span>
              <Badge tone={QUOTE_STATUS[q.status][1]}>{QUOTE_STATUS[q.status][0]}</Badge>
              <span className="ml-auto font-medium tabular-nums text-fg">{formatBRL(q.totalCents)}</span>
            </Link>
          </li>
        ))}
        {data && !data.length && <li className="px-5 py-4 text-sm text-fg-muted">Nenhum orçamento. Precisa da avaliação capilar assinada.</li>}
      </ul>
      {creating && <NewQuoteDialog onClose={() => setCreating(false)} />}
    </Card>
  );
}
